/*
 * @Author: Wot
 * @Date: 2022-04-21 15:12:42
 * @LastEditors: Wot
 * @LastEditTime: 2022-04-22 17:32:45
 * @Description: file content
 */
// 路由配置=============================================
const mainRoutes = {
  path: 'main',
  name: 'main',
  component: () => import(/* webpackChunkName: "main" */ '@/features/main/index.vue'),
  meta: {
    navtabTitle: '首页',
    isCache: true,
    ignoreDiff: [],
    menuElements: []
  }
};

export default mainRoutes;
